import React, { useEffect } from 'react';

const SEO = ({ title, description, url, canonicalUrl, image, schema, breadcrumbs, noindex }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | PocketHints` : 'PocketHints - Daily Puzzle Helper & Solver';
    const metaDesc = description || 'Daily helper for Pocket Grids, Syllo, and daily word puzzles. Get progressive hints, answers, and solvers without spoilers.';
    const rawUrl = canonicalUrl || url || (typeof window !== 'undefined' ? window.location.href : '');
    const ogImage = image || (typeof window !== 'undefined' ? `${window.location.origin}/pocket-grids-logo.png` : '');

    const toCanonical = (input) => {
      if (!input) return '';
      try {
        const origin = typeof window !== 'undefined' ? window.location.origin : '';
        const u = new URL(input, origin);
        u.search = '';
        u.hash = '';
        return u.toString();
      } catch {
        const path = typeof window !== 'undefined' ? window.location.pathname : '';
        const origin = typeof window !== 'undefined' ? window.location.origin : '';
        return `${origin}${path}`;
      }
    };

    const canonical = toCanonical(rawUrl);

    // Update Title
    document.title = fullTitle;

    // Helper to update or create meta tag
    const setMetaTag = (name, content, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Standard Meta
    setMetaTag('description', metaDesc);

    // Robots noindex
    if (noindex) {
        setMetaTag('robots', 'noindex, follow');
    } else {
        const robots = document.querySelector('meta[name="robots"]');
        if (robots) {
            robots.remove(); // Remove noindex if it exists from previous state
        }
    }

    // Canonical
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.rel = 'canonical';
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.href = canonical;

    // Open Graph
    setMetaTag('og:title', fullTitle, 'property');
    setMetaTag('og:description', metaDesc, 'property');
    setMetaTag('og:url', canonical, 'property');
    setMetaTag('og:type', 'website', 'property');
    setMetaTag('og:image', ogImage, 'property');

    // Twitter
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', fullTitle);
    setMetaTag('twitter:description', metaDesc);
    setMetaTag('twitter:image', ogImage);

    // JSON-LD Schema
    const updateSchema = (type, data) => {
       let script = document.querySelector(`script[data-schema="${type}"]`);
       if (!script) {
         script = document.createElement('script');
         script.type = 'application/ld+json';
         script.setAttribute('data-schema', type);
         document.head.appendChild(script);
       }
       script.text = JSON.stringify(data);
    };

    if (schema) {
      updateSchema('main', schema);
    }

    // Breadcrumbs Schema
    if (breadcrumbs) {
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map((crumb, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": crumb.name,
          "item": crumb.item
        }))
      };
      updateSchema('breadcrumbs', breadcrumbSchema);
    }

  }, [title, description, url, canonicalUrl, image, schema, breadcrumbs, noindex]);

  return null;
};

export default SEO;
